import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
  Button,
  IconButton,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ArticleIcon from '@mui/icons-material/Article';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import FeedbackIcon from '@mui/icons-material/Feedback';
import LogoutIcon from '@mui/icons-material/Logout';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LockResetIcon from '@mui/icons-material/LockReset';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import PeopleIcon from '@mui/icons-material/People';
import ImageIcon from '@mui/icons-material/Image';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { getCurrentUser } from '../../models/Account';


const drawerWidth = 240;

export default function Sidebar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null);
      navigate('/');
      return;
    }

    getCurrentUser().then((u) => {
      setUser(u);
      if (!u || u.role !== 'admin') {
        navigate('/');
      }
    }).catch((err) => {
      navigate('/');
      throw err;
    });
  }, [location, navigate]);


  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
    if (isMobile) setMobileOpen(false);
  };

  const handleNavigate = (path) => {
    navigate(path);
    if (isMobile) setMobileOpen(false);
  };

  const drawerContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <Box>
        <List>
          <ListItem button onClick={() => handleNavigate('/')}>
            <ListItemIcon><ArrowBackIcon /></ListItemIcon>
            <ListItemText primary="Về Trang Chủ" />
          </ListItem>

          <Divider />

          <ListItem button onClick={() => handleNavigate('/dashboard/chienky')}>
            <ListItemIcon><ArticleIcon /></ListItemIcon>
            <ListItemText primary="Quản lý Chiến Ký" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/luocsu')}>
            <ListItemIcon><HistoryEduIcon /></ListItemIcon>
            <ListItemText primary="Quản lý Lược Sử" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/phanhoi')}>
            <ListItemIcon><FeedbackIcon /></ListItemIcon>
            <ListItemText primary="Tiếp nhận phản hồi" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/hoiam')}>
            <ListItemIcon><MarkEmailReadIcon /></ListItemIcon>
            <ListItemText primary="Quản lý hồi âm" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/banner')}>
            <ListItemIcon>
              <ImageIcon />
            </ListItemIcon>
            <ListItemText primary="Thay đổi Banner" />
          </ListItem>

          <Divider sx={{ my: 1 }} />

          <ListItem button onClick={() => handleNavigate('/dashboard/changepassword')}>
            <ListItemIcon><LockResetIcon /></ListItemIcon>
            <ListItemText primary="Đổi mật khẩu" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/addadmin')}>
            <ListItemIcon><AdminPanelSettingsIcon /></ListItemIcon>
            <ListItemText primary="Tạo tài khoản Admin" />
          </ListItem>

          <ListItem button onClick={() => handleNavigate('/dashboard/accounts')}>
            <ListItemIcon><PeopleIcon /></ListItemIcon>
            <ListItemText primary="Quản lý tài khoản" />
          </ListItem>

        </List>
        <Divider />
      </Box>

      <Box p={2}>
        <Button
          variant="contained"
          color="error"
          startIcon={<LogoutIcon />}
          fullWidth
          onClick={handleLogout}
        >
          Đăng xuất
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      {isMobile && (
        <IconButton
          onClick={() => setMobileOpen(true)}
          sx={{ position: 'fixed', top: 16, left: 16, zIndex: 2000 }}
        >
          <MenuIcon />
        </IconButton>
      )}

      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
}
